<template>
  <div style="margin-bottom: 20px">
    <div
      style="margin:10px"
      :key="index"
      v-for="(following, index) in followingUsers"
    >
      <!-- Card content -->
      <div class="following-container">
        <div class="following-user-image">
          <figure class="image user-image">
            <img
              class="is-rounded"
              v-lazysizes
              :src="
                following.following_id.avatar !== '' &&
                following.following_id.avatar
                  ? following.following_id.avatar
                  : defaultImage
              "
              :style="{
                border: '2px solid ' + color,
                objectFit: 'cover',
                height: '100%',
                padding: '2px'
              }"
            />
          </figure>
        </div>
        <div class="following-user-name">
          <div class="following-name">
            <router-link
              :to="{
                name: 'profile',
                params: {
                  userId: following.following_id._id,
                  id: competitionId
                }
              }"
              ><h4 class="card-title" :style="cssVariable">
                {{ following.following_id.name }}
              </h4></router-link
            >
          </div>
        </div>
      </div>
      <hr
        style="background-color: rgba(200, 200, 200,0.5);width:100%;height:1px;margin:10px 0"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "following",
  data() {
    return {
      // color: localStorage.getItem('color') ? localStorage.getItem('color') : '#df1616',
    };
  },
  props: ["followingUsers"],
  computed: {
    defaultImage() {
      return this.$store.getters.brandLogo;
    },
    color() {
      return this.$store.getters.primaryColor;
    },
    cssVariable() {
      return {
        "--color": this.$store.getters.primaryColor,
        "--bkcolor": this.$store.getters.secondaryColor
      };
    },
    competitionId() {
      return localStorage.getItem("competitionId");
    }
  }
};
</script>

<style scoped>
.following-container {
  display: flex;
  justify-content: space-between;
}
.following-user-image {
  width: 10%;
}
.user-image {
  width: 50px;
  height: 50px;
  margin: 0 !important;
}
.following-user-name {
  width: 80%;
  margin: auto 0;
  text-align: start;
  vertical-align: middle;
}
.following-name {
  text-decoration: none;
  color: #4a4a4a;
  font-size: 20px;
  font-weight: 500;
}
.card-title {
  color: #101010;
  font-family: Cairo;
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 29px;
}
</style>
